import { useState, useCallback } from "react";
import {
  useGetAllOfflinePaymentsQuery,
  useCreateOfflinePaymentMutation,
  useUpdateOfflinePaymentMutation,
  GetAllOfflinePaymentsParams,
} from "../api/offlinePaymentApi";

export const useOfflinePayments = () => {
  const [filters, setFilters] = useState<GetAllOfflinePaymentsParams>({
    size: 10,
    page: 1,
    search: "",
    student_id: undefined,
    center_id: undefined,
    status: undefined,
    from_date: undefined,
    to_date: undefined,
  });

  const {
    data: responseData,
    isLoading: loading,
    error: apiError,
    refetch,
  } = useGetAllOfflinePaymentsQuery(filters);

  const [createPayment, { isLoading: isCreating }] = useCreateOfflinePaymentMutation();
  const [updatePayment, { isLoading: isUpdating }] = useUpdateOfflinePaymentMutation();

  const payments = responseData?.data?.items || [];
  const paginationData = {
    totalPages: responseData?.data?.totalPages || 0,
    pageSize: responseData?.data?.pageSize || 10,
    totalItems: responseData?.data?.totalItems || 0,
    currentPage: filters.page || 1,
  };
  const error = apiError ? "Failed to fetch offline payments" : null;

  const updateFilters = useCallback(
    (newFilters: Partial<GetAllOfflinePaymentsParams>) => {
      setFilters((prev) => {
        if (newFilters.page !== undefined) {
          return { ...prev, ...newFilters };
        }
        return { ...prev, ...newFilters, page: 1 };
      });
    },
    []
  );

  const handleCreate = useCallback(
    async (formData: FormData) => {
      const response = await createPayment(formData).unwrap();
      return response;
    },
    [createPayment]
  );

  const handleUpdate = useCallback(
    async (id: number | string, formData: FormData) => {
      const response = await updatePayment({ id, formData }).unwrap();
      return response;
    },
    [updatePayment]
  );

  return {
    payments,
    loading,
    error,
    filters,
    paginationData,
    updateFilters,
    refetch,
    handleCreate,
    handleUpdate,
    isCreating,
    isUpdating,
  };
};
